<template>
  <div class="calendar-key">
    <div class="key-items">
      <b>Key:</b>
      <ul>
        <li class="key-item">
          <i class="fa-duotone fa-hourglass-start module-start" aria-hidden="true"></i>
          <span>Module Start</span>
        </li>
        <li class="key-item">
          <i class="fa-duotone fa-hourglass-end module-completion" aria-hidden="true"></i>
          <span>Module Completion</span>
        </li>
        <li class="key-item">
          <i class="fas fa-circle event" aria-hidden="true"></i>
          <span>Event</span>
        </li>
        <li class="key-item">
          <i class="fas fa-circle meeting" aria-hidden="true"></i>
          <span>Meeting</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>
.calendar-key {
  padding: 10px 10px 20px 0;
}

.key-items {
  display: flex;
  flex-direction: row;
  gap: 15px;
  align-items: center;
}

.key-items ul {
  display: flex;
  flex-direction: row;
  gap: 15px;
  margin: 0;
  padding: 0;
  list-style: none;
}

.key-item {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--kate-type-light);
}

.event {
  color: var(--kate-type-blue);
}

.meeting {
  color: var(--kate-logo-magenta);
}

.module-start {
  color: var(--kate-success-alt);
}

.module-completion {
  color: var(--kate-warning);
}
</style>

<script>
export default {
  name: 'KCalendarKey',
};
</script>
